export default "__VITE_ASSET__SR5$GWpu__"